module.exports = __webpack_public_path__ + "media/images/tmrs_banner-1c60ddd83a4feff7be7d026bb45dae96.jpg";